import { Stack } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import Cart from "../components/Cart"
import CatalogButton from "../components/CatalogButton"
import CheckoutButton from "../components/CheckoutButton"

import useFrame from "../hooks/useFrame"

const CartPage: React.FC = () => {
  const { containerRef } = useFrame()

  return (
    <Stack ref={containerRef}>
      <Cart />
      <CatalogButton />
      <CheckoutButton />
    </Stack>
  )
}

export const Route = createFileRoute("/cart")({
  component: CartPage,
})

export default CartPage
